/**
 * ListEditor.jsx - ListEditor - Main editor for list items
 * 
 * CHANGE HISTORY:
 * - 251018_1327 [43ebfec] danielbeer: refactor: restructure packages - extract all nested packages to top level
 */
import React, { useState } from 'react';
import { useOrganizr } from '../src/OrganizrContext';
import ListItem from './ListItem.jsx';

const ListEditor = ({ list, onShowIconGallery }) => {
  const { updateList, addItem, reorderItems } = useOrganizr();
  const [editingName, setEditingName] = useState(false);
  const [draggedItem, setDraggedItem] = useState(null);
  
  const handleUpdateName = (newName) => {
    updateList(list.id, { name: newName });
    setEditingName(false);
  };
  
  const handleAddItem = () => {
    addItem(list.id, {
      name: 'New Item',
      color: list.color
    });
  };
  
  const handleDragStart = (e, item) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = 'move';
  };
  
  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };
  
  const handleDrop = (e, targetItem) => {
    e.preventDefault();
    
    if (!draggedItem || draggedItem.id === targetItem.id) return;
    
    const items = [...list.children];
    const draggedIndex = items.findIndex(i => i.id === draggedItem.id);
    const targetIndex = items.findIndex(i => i.id === targetItem.id);
    
    items.splice(draggedIndex, 1);
    items.splice(targetIndex, 0, draggedItem);
    
    reorderItems(list.id, items.map(i => i.id));
    setDraggedItem(null);
  };
  
  return (
    <div className="list-editor">
      <div className="list-editor-header">
        {editingName ? (
          <input
            type="text"
            value={list.name}
            onChange={(e) => updateList(list.id, { name: e.target.value })}
            onBlur={() => setEditingName(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') setEditingName(false);
              if (e.key === 'Escape') setEditingName(false);
            }}
            className="list-name-input"
            autoFocus
          />
        ) : (
          <h2 onClick={() => setEditingName(true)} className="list-name">
            <span style={{ color: list.color }}>{list.icon}</span>
            {list.name}
          </h2>
        )}
        
        <div className="list-editor-actions">
          <input
            type="color"
            value={list.color}
            onChange={(e) => updateList(list.id, { color: e.target.value })}
            className="list-color-picker"
            title="Change color"
          />
          <button onClick={onShowIconGallery} className="btn-change-icon" title="Change icon">
            {list.icon}
          </button>
          <button onClick={handleAddItem} className="btn-add-item">
            + Add Item
          </button>
        </div>
      </div>
      
      <div className="list-editor-body">
        {list.children && list.children.length > 0 ? (
          <div className="list-items">
            {list.children.map(item => (
              <ListItem
                key={item.id}
                item={item}
                listId={list.id}
                onDragStart={(e) => handleDragStart(e, item)}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, item)}
              />
            ))}
          </div>
        ) : (
          <div className="list-editor-empty">
            <p>No items yet</p>
            <button onClick={handleAddItem} className="btn-add-first-item">
              Add First Item
            </button>
          </div>
        )}
      </div>
      
      <div className="list-editor-footer">
        <div className="list-metadata">
          <span>{list.children?.length || 0} items</span>
          <span>•</span>
          <span>Updated {new Date(list.updatedAt).toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default ListEditor;
